module.exports = __webpack_public_path__ + "static/images/home-head-bg.2cd77af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-head-bg.png
// module id = QigH
// module chunks = 8